import Person from "./scripts/Person";
import ExampleReactComponent from "./scripts/ExampleReactComponent";
import React from "react";
import ReactDOM from "react-dom";

const person1 = new Person("Brad");
if (document.querySelector("#render-react-example-here")) {
  ReactDOM.render(
    <ExampleReactComponent />,
    document.querySelector("#render-react-example-here")
  );
}

const employeesHero = document.getElementById("employees");
if (employeesHero) {
  const employeesSlider = new Swiper("#employees", {
    slidesPerView: 1,
    breakpoints: {
      1280: {
        slidesPerView: 4,
      },
      600: {
        slidesPerView: 2,
      }
    },
    pagination: {
      el: "#employees .swiper-pagination",
    },
    navigation: {
      nextEl: "#employees .swiper-button-next",
      prevEl: "#employees .swiper-button-prev",
    },
  });
}

const councilHero = document.getElementById("council");
if (councilHero) {
  const councilSlider = new Swiper("#council", {
    slidesPerView: 1,
    breakpoints: {
      1280: {
        slidesPerView: 5,
      },
      1024: {
        slidesPerView: 4,
      },
      590: {
        slidesPerView: 2,
      }
    },
    pagination: {
      el: "#council .swiper-pagination",
    },
    navigation: {
      nextEl: "#council .swiper-button-next",
      prevEl: "#council .swiper-button-prev",
    },
  });
}

const containers = [
  ...document.querySelectorAll(".reveal"),
  ...document.querySelectorAll(".reveal-left"),
  ...document.querySelectorAll(".reveal-300"),
  ...document.querySelectorAll(".reveal-600"),
  ...document.querySelectorAll(".reveal-right"),
];
const windowHeight = window.innerHeight;
if (containers.length > 0) {
  function reveal() {
    containers.forEach((container) => {
      const containerTop = container.getBoundingClientRect().top;
      if (containerTop < windowHeight) {
        container.classList.add("reveal-show");
      }
    });
  }

  window.addEventListener("scroll", reveal);
  document.addEventListener("DOMContentLoaded", reveal);
}

const yearElement = document.getElementById("year");
const currentDate = new Date();
const currentYear = currentDate.getFullYear();

yearElement.innerText = currentYear.toString();

const modalBackground = document.getElementById("modal-background");

if (modalBackground) {
  modalBackground.addEventListener("click", () => {
    const allQuoteModals = document.querySelectorAll("[data-modal]");
    [...allQuoteModals].forEach((qouteModal) => {
      !qouteModal.classList.contains("hidden") && closeModal(qouteModal);
    });
  });

  const closeCurrentModal = (currentModal) => {
    const currentModalData = currentModal.attributes["data-modal"]?.value;
    const currentCloseButton = document.querySelector(
      `[data-close="${currentModalData}"]`
    );

    currentCloseButton.addEventListener("click", () => {
      closeModal(currentModal);
    });
  };

  const closeModal = (modal) => {
    modalBackground.classList.remove("hidden");
    modal.classList.add("animate__animated", "animate__fadeOut");
    document.body.classList.remove("overflow-hidden");
    setTimeout(function () {
      modalBackground.classList.add("hidden");
      modal.classList.add("hidden");
      modal.classList.remove("animate__fadeOut");
    }, 500);
  };

  const quotesContainer = document.getElementById("quotes");
  quotesContainer.addEventListener("click", (e) => {
    if (e.target.nodeName === "BUTTON") {
      const currentQuote = e.target?.attributes["data-quote"]?.value;
      const currentModal = document.querySelector(
        `[data-modal="${currentQuote}"]`
      );

      modalBackground.classList.remove("hidden");
      currentModal && currentModal.classList.remove("hidden");
      currentModal &&
        currentModal.classList.add("animate__animated", "animate__fadeIn");
      currentModal && closeCurrentModal(currentModal);
      currentModal && document.body.classList.add("overflow-hidden");
    }
  });
}

const heroSliderContainer = document.querySelector(".hero-slider");

if (heroSliderContainer) {
  const heroSlider = new Swiper("#heroSlider", {
    loop: true,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
  }); 
}

const gallerySliderContainer = document.getElementById(
  "gallerySliderContainer"
);

if (gallerySliderContainer) {
  const tailwindContainer = document.getElementsByClassName("container")[0];
  const updateGallerySliderContainer = () => {
    const computedStyle = window.getComputedStyle(tailwindContainer);
    const containerWidth = parseInt(computedStyle.getPropertyValue("width"));
    const halfContainerWidth = containerWidth / 2;
    const widthToSet =
      window.innerWidth < 1024 ? containerWidth : halfContainerWidth;
    gallerySliderContainer.style.maxWidth = widthToSet.toString() + "px";
  };
  document.addEventListener("DOMContentLoaded", () =>
    updateGallerySliderContainer()
  );
  window.addEventListener("resize", () => updateGallerySliderContainer());

  const swiperGalleryCarousel = new Swiper(".swiper-gallery-carousel", {
    spaceBetween: 20,
    slidesPerView: 4,
    freeMode: true,
    watchSlidesProgress: true,
    breakpoints: {
      1280: {
        slidesPerView: 5,
      },
    },
  });

  const swiperGalleryTop = new Swiper(".swiper-gallery-top", {
    spaceBetween: 10,
    navigation: {
      nextEl: ".thubmnails-navigation .swiper-button-next",
      prevEl: ".thubmnails-navigation .swiper-button-prev",
    },
    thumbs: {
      swiper: swiperGalleryCarousel,
    },
  });
}

const swiperPhotosSliders = document.querySelectorAll(".swiper-photos-slider");

swiperPhotosSliders.forEach((slider) => {
  new Swiper(slider, {
    slidesPerView: 1,
    spaceBetween: 32,
    navigation: {
      nextEl: "#sliderPhotosNavigation .swiper-button-next",
      prevEl: "#sliderPhotosNavigation .swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      type: "fraction",
    },
    breakpoints: {
      1024: {
        slidesPerView: 2,
      },
      1536: {
        slidesPerView: 3,
      },
    },
  });
});

const sliderContainer = document.getElementById("sliderContainer");
const sectionsToRight = document.querySelectorAll(".slider-mask");

const updateSectionPositionToContainerSize = (container) => {
  const computedStyle = window.getComputedStyle(container);
  const marginLeft = computedStyle.getPropertyValue("margin-left");
  const height = window
    .getComputedStyle(sliderContainer)
    .getPropertyValue("height");

  sectionsToRight.forEach((section) => {
    section.style.marginLeft = marginLeft;
    section.style.height = height;
  });
};

if (sectionsToRight && sliderContainer) {
  const tailwindContainer = document.getElementsByClassName("container")[0];
  document.addEventListener("DOMContentLoaded", () =>
    updateSectionPositionToContainerSize(tailwindContainer)
  );
  window.addEventListener("resize", () =>
    updateSectionPositionToContainerSize(tailwindContainer)
  );
}

const tabButtons = document.querySelectorAll(".button--tab");
const tabContents = document.querySelectorAll(".tab-content");

tabButtons.forEach((button) => {
  button.addEventListener("click", (e) => {
    const tabIndex = button.dataset.tab;
    tabButtons.forEach((btn) => btn.classList.remove("active"));
    e.target.classList.add("active");

    tabContents.forEach((content) => {
      if (content.dataset.content === tabIndex) {
        content.classList.add("active");
      } else {
        content.classList.remove("active");
      }
    });
  });
});

const initAccordion = (accordion) => {
  const accordionItems = accordion.querySelectorAll(".accordion-item");
  const toggledAccordion = document.getElementById("toggledAccordion");
  const hash = new URL(window.location).hash;
  if (toggledAccordion && hash) {
    const currentUrlSector = document.querySelector(hash);
    currentUrlSector.classList.add("active");
  }

  accordionItems.forEach((item) => {
    const header = item;
    const content = item.nextElementSibling;

    // Add click event listener to accordion header
    header.addEventListener("click", () => {
      // Toggle open accordion
      const accordionType = item.attributes["data-accordion"];
      if (accordionType && accordionType.value === "toggle-accordion") {
        const toggledItems = document.querySelectorAll(
          "[data-accordion='toggle-accordion']"
        );
        if (item.classList.contains("active"))
          return item.classList.remove("active");

        toggledItems.forEach((toggledItem) =>
          toggledItem.classList.remove("active")
        );
      }

      item.classList.toggle("active");
      content.classList.toggle("active");
      const buttonApply = document.querySelector(`[data-button="apply"]`);

      if (buttonApply) {
        buttonApply.addEventListener("click", (e) => e.stopPropagation());
      }

      if (content.parentElement.classList.contains("accordion--buttons")) {
        const button = document.querySelector(
          `[data-accordion='${item.attributes["data-button"].value}']`
        );
        if (item.classList.contains("active")) {
          button.innerText = "Zamknij";
        } else {
          button.innerText = "Szczegóły";
        }
      }

      // If there's a nested accordion, initialize it
      const nestedAccordion = content.querySelector(".accordion");
      if (nestedAccordion) {
        initAccordion(nestedAccordion);
      }
    });
  });
};

const accordions = document.querySelectorAll(".accordion");
accordions.forEach((accordion) => {
  initAccordion(accordion);
});

const mapBtn = document.getElementById("showMapBtn");

if (mapBtn) {
  document.getElementById("showMapBtn").addEventListener("click", function () {
    const mapContainer = document.getElementById("googleMap");
    const btn = document.getElementById("showMapBtn");

    if (
      mapContainer.style.opacity === "0" ||
      mapContainer.style.opacity === ""
    ) {
      mapContainer.style.opacity = "1";
      mapContainer.style.pointerEvents = "all";
      btn.style.opacity = "0";
      btn.style.pointerEvents = "none";

      const coords = new google.maps.LatLng(50.060870, 19.933790);
      const marker = new google.maps.Marker({
        position: coords,
        title:"Ośrodek Multimodalnych Badań Edukacyjnych i Kulturowych"
    });

      const mapOptions = {
        center: coords,
        zoom: 15,
      };


      const map = new google.maps.Map(mapContainer, mapOptions);
      marker.setMap(map);
    } else {
      mapContainer.style.opacity = "0";
      mapContainer.style.pointerEvents = "none";
      btn.style.opacity = "1";
      btn.style.pointerEvents = "all";
    }
  });
}

const hamburger = document.getElementById("hamburger");
const nav = document.getElementById("navigation");
const mobileMenu = document.getElementById("mobileMenu");

hamburger.addEventListener("click", () => {
  nav.classList.toggle("active");
  mobileMenu.classList.toggle("-right-full");
});

mobileMenu.addEventListener("click", e => {
  e.stopPropagation();
  if (e.target.nodeName === "BUTTON") {
    e.target.previousSibling.classList.toggle('active');
  }
})

const currentUrl = window.location.href;
const menuItems = document.querySelectorAll("#navList .menu-item");

const getPathWithoutEdgeSlashes = (urlPath) =>
  urlPath.slice(1, urlPath.length - 1);
const getPathElements = (urlPath) => urlPath.split("/");

const currentPathURL = new URL(currentUrl).pathname;
const currentPath = getPathWithoutEdgeSlashes(currentPathURL);
const currentPathElements = getPathElements(currentPath);

menuItems.forEach(function (menuItem) {
  const link = menuItem.querySelector("a");
  const href = link.getAttribute("href");

  if (currentUrl.includes(href)) {
    menuItem.classList.add("active");
    const subMenuLinks = menuItem.querySelectorAll(".sub-menu-item a");

    subMenuLinks.forEach((link) => {
      const itemUrl = new URL(link.getAttribute("href")).pathname;
      const menuItemsPath = getPathWithoutEdgeSlashes(itemUrl);
      const menuItemsPathElements = getPathElements(menuItemsPath);

      if (
        menuItemsPathElements[menuItemsPathElements.length - 1] ===
        currentPathElements[currentPathElements.length - 1]
      ) {
        link.parentElement.classList.add("active");
      }
    });
  }
});

const audioElement = document.getElementById("audioElement");
const playPauseButton = document.getElementById("playPauseButton");

if (playPauseButton) {
  playPauseButton.addEventListener("click", function () {
    if (audioElement.paused) {
      audioElement.play();
      playPauseButton.classList.remove("play");
      playPauseButton.classList.add("pause");
    } else {
      audioElement.pause();
      playPauseButton.classList.remove("pause");
      playPauseButton.classList.add("play");
    }
  });
}



document.addEventListener('DOMContentLoaded', function() {
  const fontSizeToggle = document.getElementById('fontSizeToggle');
  const a11yToggle = document.getElementById('a11yToggle');
  const savedFontSize = localStorage.getItem('fontSize');
  const savedA11y = localStorage.getItem('a11y');
  const body = document.body;

  if (savedFontSize) {
    body.classList.add(savedFontSize);
  }

  if (savedA11y) {
    body.classList.add(savedA11y);
  }
  
  fontSizeToggle.addEventListener('click', function() {
    body.classList.toggle('font-lg');
    localStorage.setItem('fontSize', body.classList.contains('font-lg') ? 'font-lg' : '');
  });  
  a11yToggle.addEventListener('click', function() {
    body.classList.toggle('a11y');
    localStorage.setItem('a11y', body.classList.contains('a11y') ? 'a11y' : '');
  });
});

document.addEventListener('DOMContentLoaded', function () {
  var cookieBar = document.getElementById('cookieConsentBar');
  var acceptCookie = document.getElementById('acceptCookie');

  // Check if the cookie already exists
  if (!getCookie('cookieConsent')) {
      cookieBar.style.display = 'block';
  }

  // Set a cookie when the user accepts
  acceptCookie.addEventListener('click', function () {
      setCookie('cookieConsent', 'accepted', 365);
      cookieBar.style.display = 'none';
  });

  function setCookie(name, value, days) {
      var expires = "";
      if (days) {
          var date = new Date();
          date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
          expires = "; expires=" + date.toUTCString();
      }
      document.cookie = name + "=" + (value || "") + expires + "; path=/";
  }

  function getCookie(name) {
      var nameEQ = name + "=";
      var ca = document.cookie.split(';');
      for (var i = 0; i < ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) == ' ') c = c.substring(1, c.length);
          if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
      }
      return null;
  }
});

